import {
    FETCH_SCHEMES_PLAN_REQUEST,
    FETCH_SCHEMES_PLAN_SUCCESS,
    FETCH_SCHEMES_PLAN_FAILURE,
  } from "./FetchMedSchemePlanTypes";
  
  const initialState = {
    loading: false,
    schemesPlan: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SCHEMES_PLAN_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_SCHEMES_PLAN_SUCCESS:
        return {
          loading: false,
          schemesPlan: action.payload,
          error: "",
        };
      case FETCH_SCHEMES_PLAN_FAILURE:
        return {
          loading: false,
          schemesPlan: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  